/**
 * 动画组件
 * @ignore
 * @module AnimateComponent
 */
'use strict';
define([
    '../base/PureComponent',
    '../utils/CommonUtil',
    '../utils/LayerUtil',
    '../utils/RenderUtil',
    '../utils/SpatialOPUtil',
    '../utils/GeometryUtil',
    '../g2'
], function(
    PureComponent,
    CommonUtil,
    LayerUtil,
    RenderUtil,
    SpatialOPUtil,
    GeometryUtil,
    g2
) {
    var timerFactory = {
        timers: {},
        timerMethod: {},
        getTimer: function(interval) {
            var self = this;
            if (!this.timers[interval]) {
                this.timerMethod[interval] = {};
                this.timers[interval] = setInterval(function() {
                    self.play(interval);
                }, interval);
            }
            /**
             * 添加一个需要执行的函数
             * */
            this.timers.addTimerMothed = function(interval, id, fn, param, ctx) {
                    if (self.timerMethod[interval]) {
                        self.timerMethod[interval][id] = {
                            fn: fn,
                            ctx: ctx,
                            param: param
                        }
                    } else {
                        throw new Error("指定的定时器方法不存在！");
                    }
                }
                //删除定时器的方法
            this.timers.deleteTimerMethod = function(interval, id) {
                var isDelete = false;
                if (self.timerMethod[interval]) {
                    if (self.timerMethod[interval][id]) {
                        delete self.timerMethod[interval][id];
                        isDelete = true;
                    }
                } else {
                    throw new Error("指定的定时器方法不存在！");
                }
                return isDelete;
            }
            this.timers.timerMethodsIsEmpty = function(interval) {
                if (!self.timerMethod) {
                    return false;
                }
                if (self.timerMethod[interval]) {
                    return Object.keys(self.timerMethod[interval]).length == 0;
                } else {
                    return false;
                }
            }
            return this.timers;
        },
        clearTimer: function(timerObj, interval) {
            if (timerObj[interval]) {
                window.clearInterval(timerObj[interval]);
                delete timerObj[interval];
            } else {
                throw new Error("指定的定时器不存在！");
            }
        },
        play: function(interval) {
            if (Object.keys(this.timerMethod[interval]).length > 0) {
                var methods = this.timerMethod[interval];
                for (var key in methods) {
                    methods[key].fn.call(methods[key].ctx, methods[key].param, methods[key].fn);
                }
            }
        },
    };
    /**
     * @ignore
     * @constructor
     * @classdesc 动画组件
     * @alias G.components.AnimateComponent
     * @augments G.base.PureComponent
     * @param options {Object} 必填
     * @param options.map {G.Map} 必填，地图对象
     * @param options.layerId {String} 可选，图层id，不传自动创建新图层
     */
    var component = PureComponent.extend({
        options: {},
        initialize: function(options) {
            PureComponent.prototype.initialize.call(this, options);
            //
            var g2Map = this.map.getMap();
            this.options.layerId = this.options.layerId || CommonUtil.newUUID32();
            var layer = LayerUtil.getLayerById(this.map, this.options.layerId);
            if (!layer) {
                layer = new g2.carto.ElementLayer({
                    id: this.options.layerId,
                    map: g2Map
                });
                g2Map.addLayer(layer);
            }
            this._layer = layer;
            //
            this._timerMap = {};
            //popup ts-gis TooltipWare组件
            this._toolTipWare = new g2.widget.TooltipWare({
                map: g2Map
            });
            /************************图标在线段上的移动效果**********************************/
            //创建一个不同间隔的定时器的容器对象
            this._differenceTimer = {};
        },
        /**
         * 销毁
         * @method
         */
        destroy: function() {
            //清除所有定时器
            for (var k in this._timerMap) {
                this.clear(k);
            }
            var g2Map = this.map.getMap();
            this._layer.clear();
            g2Map.removeLayer(this._layer);
            //
            PureComponent.prototype.destroy.call(this);
        }
    });
    component.include({
        /**
         * 图标闪动
         * @method
         * @memberOf G.components.AnimateComponent.prototype
         * @param opts {Object}
         * @param opts.point {Array} 必填，[x,y] 地图坐标，要求坐标系与地图坐标系一致；
         * @param opts.process  {Array} 必填，播放动画的图标数组
         * @param opts.interval {Number} 可选，闪烁的间隔，单位毫秒，默认为200
         * @param opts.cost {Number} 可选，播放总时长，单位毫秒，默认3000
         * @param opts.tooltip {Object} 可选，显示的标注配置，默认为false
         * @param opts.tooltip.html {String} 必填，内容html字符串
         * @param opts.tooltip.offset {Array} 可选 水平垂直方向的偏移值，单位像素，[offsetX,offsetY]
         * @param opts.tooltip.className {String} 必填，样式名称
         * @returns {String} 动画元素id
         * @example
         * var options={
         *       //位置
         *       point:[116,35],
         *       //闪烁间隔，单位毫秒
         *       interval:200,
         *       //变化过程数组，可以两个或者多个元素
         *       process:[
         *           {
         *               //图片base64字符串
         *               source:'图片base64字符串',
         *               //图片宽
         *               width:20,
         *               //图片高
         *               height:20
         *           },
         *           {
         *               source:'图片base64字符串',
         *               width:30,
         *              height:30
         *           }
         *       ],
         *       //动画时长，单位毫秒
         *       cost:5000
         *   }
         * animateComponent.blinkIconMaker(options);
         */
        blinkIconMaker: function(opts) {
            opts = opts || {};
            if (!(CommonUtil.isArray(opts.point) && opts.point.length == 2)) {
                throw (new Error('point参数错误！'));
            }
            if (opts.process.length < 1) {
                throw (new Error('process参数错误！'));
            }
            var g2Map = this.map.getMap(),
                point = new g2.sfs.Point({
                    x: opts.point[0],
                    y: opts.point[1],
                    spatialReference: g2Map.spatialReference
                }),
                process = opts.process,
                interval = isNaN(opts.interval) ? 200 : parseFloat(opts.interval),
                cost = isNaN(opts.cost) ? 3000 : parseFloat(opts.cost);
            var symbolArr = [];
            for (var i = 0, len = process.length; i < len; i++) {
                var proceeItem = process[i];
                var symbol = new g2.sfs.PictureMarkerSymbol({
                    source: proceeItem.source,
                    width: proceeItem.width,
                    height: proceeItem.height,
                    offsetX: proceeItem.width / 2,
                    offsetY: proceeItem.height / 2,
                    opacity: 1
                });
                symbolArr.push(symbol);
            }
            var index = 0;
            var id = CommonUtil.newUUID();
            //创建元素
            var element = new g2.sfs.Element({
                id: id,
                geometry: point,
                symbol: symbolArr[index]
            });
            this._layer.add(element);
            if (opts.tooltip) {
                var tooltip = jQuery.extend(true, {}, opts.tooltip);
                var tipHtml = tooltip.html || '<div>test</div>';
                tooltip.id = id;
                tooltip.offset = tooltip.offset || [10, -10];
                tooltip.className = tooltip.className || 'g2-tooltip';
                tooltip.layerId = this._layer.getLayerId();
                var newTooltip = new g2.widget.Tooltip({
                    id: tooltip.id,
                    anchor: point, //提示在地图上停靠位置
                    content: tipHtml, //提示内容
                    layerId: tooltip.layerId, //提示所在图层ID
                    offset: tooltip.offset, //位置偏移量
                    className: tooltip.className //tooltip样式
                });
                this._toolTipWare.add(newTooltip);
            }
            var self = this;
            var duaring = 0;
            //
            var timer = setInterval(function() {
                index++;
                if (index >= symbolArr.length) {
                    index %= symbolArr.length;
                }
                //
                element.symbol = symbolArr[index];
                self._layer.update(element, true);
                duaring += interval;
                //
                if (duaring >= cost) {
                    self.clear(id);
                }
            }, interval);
            //
            this._timerMap[id] = timer;
            //
            return id;
        },
        /**
         * 矢量点渐变闪动
         * @method
         * @memberOf G.components.AnimateComponent.prototype
         * @param opts {Object}
         * @param opts.point {Array} 必填，[x,y] 地图坐标，要求坐标系与地图坐标系一致；
         * @param opts.style {String} 可选，形状，默认是circle,可选值：circle/square/star/x/cross/triangle
         * @param opts.startSize {Number} 可选，起始尺寸,默认为3
         * @param opts.endSize {Number} 可选，最终尺寸,默认为10
         * @param opts.interval {Number} 可选，播放每帧的间隔，单位毫秒，默认为80
         * @param opts.cost {Number} 可选，播放总时长，单位毫秒，默认3000
         * @param opts.borderColor {Object} 可选，边框色，颜色 默认为  {"alpha": 255, "r": 255, "g": 0, "b": 0}
         * @param opts.borderWidth {Object} 可选，边框宽度，颜色 默认为 0
         * @param opts.fillColor {Object} 可选，填充色，颜色 默认为  {"alpha": 255, "r": 255, "g": 0, "b": 0}
         * @param opts.tooltip {Object} 可选，显示的标注配置，默认为false
         * @param opts.tooltip.html {String} 必填，内容html字符串
         * @param opts.tooltip.offset {Array} 可选 水平垂直方向的偏移值，单位像素，[offsetX,offsetY]
         * @param opts.tooltip.className {String} 必填，样式名称
         * @returns {String} 动画元素id
         * @example
         * var options={
         *       //位置
         *       point:[116,35],
         *       //闪烁间隔，单位毫秒
         *       interval:50,
         *       //填充颜色
         *       fillColor:{"alpha": 200, "r": 200, "g": 0, "b": 0},
         *       //动画时长，单位毫秒
         *       cost:5000
         *   }
         * animateComponent.blinkVectorMarker(options);
         *
         */
        blinkVectorMarker: function(opts) {
            opts = opts || {};
            if (!(CommonUtil.isArray(opts.point) && opts.point.length == 2)) {
                throw (new Error('参数错误！'));
            }
            var g2Map = this.map.getMap(),
                point = new g2.sfs.Point({
                    x: opts.point[0],
                    y: opts.point[1],
                    spatialReference: g2Map.spatialReference
                }),
                style = opts.style || 'circle',
                startSize = isNaN(opts.startSize) ? 3 : parseFloat(opts.startSize),
                endSize = isNaN(opts.endSize) ? 20 : parseFloat(opts.endSize),
                interval = isNaN(opts.interval) ? 80 : parseFloat(opts.interval),
                cost = isNaN(opts.cost) ? 3000 : parseFloat(opts.cost),
                step = endSize > startSize ? 1 : -1,
                borderColor = opts.borderColor || {
                    "a": 100,
                    "r": 0,
                    "g": 0,
                    "b": 250
                },
                borderWidth = isNaN(opts.borderWidth) ? 1 : parseFloat(opts.borderWidth),
                fillColor = opts.fillColor || {
                    "a": 200,
                    "r": 0,
                    "g": 0,
                    "b": 250
                };

            var g2borderColor = RenderUtil.object2Color(borderColor),
                g2fillColor = RenderUtil.object2Color(fillColor);
            var symbol = new g2.sfs.SimpleMarkerSymbol({
                style: style,
                fillColor: g2fillColor,
                borderColor: g2borderColor,
                size: startSize,
                borderThickness: borderWidth
            });
            var id = CommonUtil.newUUID();
            //创建元素
            var element = new g2.sfs.Element({
                id: id,
                geometry: point,
                symbol: symbol
            });
            this._layer.add(element);
            if (opts.tooltip) {
                var tooltip = jQuery.extend(true, {}, opts.tooltip);
                var tipHtml = tooltip.html || '<div>test</div>';
                tooltip.id = id;
                tooltip.offset = tooltip.offset || [10, -10];
                tooltip.className = tooltip.className || 'g2-tooltip';
                tooltip.layerId = this._layer.getLayerId();
                var newTooltip = new g2.widget.Tooltip({
                    id: tooltip.id,
                    anchor: point, //提示在地图上停靠位置
                    content: tipHtml, //提示内容
                    layerId: tooltip.layerId, //提示所在图层ID
                    offset: tooltip.offset, //位置偏移量
                    className: tooltip.className //tooltip样式
                });
                this._toolTipWare.add(newTooltip);
            }
            var self = this;
            var duaring = 0;
            //
            var timer = setInterval(function() {
                var symbol = element.symbol;
                var size = element.symbol.size;
                size += step;
                element.symbol.size = size;
                self._layer.update(element, true);
                //
                if ((size - startSize) * (size - endSize) >= 0) {
                    step *= -1;
                }
                duaring += interval;
                //
                if (duaring >= cost) {
                    self.clear(id);
                }
            }, interval);
            //
            this._timerMap[id] = timer;
            //
            return id;
        },
        /**
         * 图标旋转
         * @method
         * @memberOf G.components.AnimateComponent.prototype
         * @param options {Object} 必填
         * @param options.point {Array} 必填，[x,y] 地图坐标，要求坐标系与地图坐标系一致；
         * @param options.source {String} 必填，图片的base64位
         * @param options.width {Number} 必填，图片的宽度
         * @param options.height {Number} 必填，图片的高度
         * @param options.speed {Number} 可选，旋转的速度
         * @param options.tooltip {Object} 可选，显示的标注配置，默认为false
         * @param options.tooltip.html {String} 必填，内容html字符串
         * @param options.tooltip.offset {Array} 可选 水平垂直方向的偏移值，单位像素，[offsetX,offsetY]
         * @param options.tooltip.className {String} 必填，样式名称
         * @returns {String} 动画元素id
         * @example
         * animateCom.rotationIconMaker({
         *	point: [124, 35.5],
         *	speed: 100,
         *	source:'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',
         *	width:50,
         *	height:50
         * });
         */
        rotationIconMaker: function(options) {
            if (!options) {
                return
            };
            if (!(CommonUtil.isArray(options.point) && options.point.length == 2) || !options.source) {
                throw (new Error('参数错误！'));
            }
            var width = isNaN(options.width) ? 50 : parseFloat(options.width),
                height = isNaN(options.height) ? 50 : parseFloat(options.height),
                speed = isNaN(options.speed) ? 200 : parseFloat(options.speed),
                rotation = 360;
            var g2Map = this.map.getMap(),
                point = new g2.sfs.Point({
                    x: options.point[0],
                    y: options.point[1],
                    spatialReference: g2Map.spatialReference
                });
            var symbol = new g2.sfs.PictureMarkerSymbol({
                source: options.source,
                rotation: rotation,
                width: options.width,
                height: options.height,
                opacity: 1,
                offsetX: options.width / 2,
                offsetY: options.height / 2
            });
            var id = CommonUtil.newUUID();
            //创建元素
            var element = new g2.sfs.Element({
                id: id,
                geometry: point,
                symbol: symbol
            });
            this._layer.add(element);
            if (options.tooltip) {
                var tooltip = jQuery.extend(true, {}, options.tooltip);
                var tipHtml = tooltip.html || '<div>test</div>';
                tooltip.id = id;
                tooltip.offset = tooltip.offset || [10, -10];
                tooltip.className = tooltip.className || 'g2-tooltip';
                tooltip.layerId = this._layer.getLayerId();
                var newTooltip = new g2.widget.Tooltip({
                    id: tooltip.id,
                    anchor: point, //提示在地图上停靠位置
                    content: tipHtml, //提示内容
                    layerId: tooltip.layerId, //提示所在图层ID
                    offset: tooltip.offset, //位置偏移量
                    className: tooltip.className //tooltip样式
                });
                this._toolTipWare.add(newTooltip);
            }
            var self = this;
            var timer = setInterval(function() {
                var ele = self._layer.find(id);
                rotation -= 20;
                ele.symbol.rotation = rotation;
                self._layer.update(ele, true);
                if (rotation == 0) {
                    rotation = 360;
                }
            }, speed);
            this._timerMap[id] = timer;
            //
            return id;
        },
        /**
         * 图标在线段上的移动效果
         * @method
         * @memberOf G.components.AnimateComponent.prototype
         * @param options {Object} 必填
         * @param options.pathGeojson  {wkt/geometry} 必填，路径点wkt数据和geometry数据都可以 注：坐标系和map的坐标系相同
         * @param options.source {String} 必填，图片的base64位
         * @param options.width {Number} 必填，图片的宽度
         * @param options.height {Number} 必填，图片的高度
         * @param options.speed {Number} 可选，速度 m/s
         * @param options.isShowLine {Boolean} 可选，是否展示线段
         * @param options.lineStyle {Number} 可选，线的样式，简单直线样式,Dash = 0, DashDot = 1, DashDotDot = 2, Dot = 3, Null = 4,Solid = 5
         * @param options.lineWidth {Number} 可选，线的宽度
         * @param options.lineColor {Object} 可选，例如：{ a: 153, r: 0, g: 0, b: 255 }
         * @param options.text {String} 可选，展示的文字内容
         * @param options.size {Number} 可选，展示的文字大小。默认：15
         * @param options.offsetX {Number} 可选，展示的文字的偏移量X轴。默认：0
         * @param options.offsetY {Number} 可选，展示的文字的偏移量Y轴。默认：-21
         * @param options.foreground {Object} 可选，展示的文字的文字颜色。默认：{ a: 255, r: 255, g: 0, b: 0}
         * @param options.borderColor {Object} 可选，展示的文字的边框颜色。默认：{ a: 255, r: 255, g: 0, b: 0}
         * @param options.borderThickness {Number} 可选，展示的文字的边框宽度。默认：0.1
         * @param options.fontFamilyName {String} 可选，展示的文字的字体
         * @param options.fontWeight {String} 可选，展示的文字的字号
         * @param options.textAlign {String} 可选，文本水平对齐方式,可用值：left、right、center、end、start，默认值为center
         * @param options.interval {Number} 可选，播放每帧的间隔，单位毫秒，默认为80
         * @param options.isRotate {Boolean} 可选，图标是否自动旋转  旋转true/不旋转false
         * @param options.textIsRotate {Boolean} 可选，文字是否自动旋转  旋转true/不旋转false
         * @param options.tooltip {Object} 可选，显示的标注配置，默认为false
         * @param options.tooltip.html {String} 必填，内容html字符串
         * @param options.tooltip.offset {Array} 可选 水平垂直方向的偏移值，单位像素，[offsetX,offsetY]
         * @param options.tooltip.className {String} 必填，样式名称
         * @param callback {Function} 可选，回调函数
         * @param context {Object} 可选，上下文
         * @return string {String} 返回点和线的id，用来清除地图上的要素 例：'123,321'
         * */
        iconMoveOnLine: function(options, callback, context) {
            if (!options.pathGeojson || !options.source ||
                !options.width || !options.height) {
                throw (new Error('参数错误！'));
            }
            var speed = isNaN(options.speed) ? 2 : parseFloat(options.speed),
                lineStyle = isNaN(options.lineStyle) ? 5 : parseFloat(options.lineStyle),
                lineWidth = isNaN(options.lineWidth) ? 3 : parseFloat(options.lineWidth),
                lineColor = options.lineColor || {
                    a: 153,
                    r: 0,
                    g: 0,
                    b: 255
                },
                interval = isNaN(options.interval) ? 80 : parseFloat(options.interval),
                isRotate = options.isRotate || false,
                textIsRotate = options.textIsRotate || false,
                isShowLine = options.isShowLine,
                geom = {},
                tooltip = options.tooltip || false;
            if (isShowLine == undefined) {
                isShowLine = true;
            }
            if (typeof options.pathGeojson == "string") {
                geom = GeometryUtil.getWktReader().read(options.pathGeojson);
            } else {
                geom = GeometryUtil.getGeoJSONReader().read(options.pathGeojson);
            }
            var geomtry = GeometryUtil.getGeoJSONWriter().write(geom);
            //先画一条线
            var ploylineSymbol = new g2.sfs.SimpleLineSymbol({
                style: lineStyle,
                width: lineWidth,
                color: new g2.sfs.Color(lineColor)
            });
            var polyline = new g2.sfs.Polyline({
                spatialReference: this.map.getMap().spatialReference
            });
            //构造path实例
            var path = new g2.sfs.Path({
                spatialReference: this.map.getMap().spatialReference
            });
            for (var i = 0; i < geomtry.coordinates.length; i++) {
                var linePoint = new g2.sfs.Point({
                    x: geomtry.coordinates[i][0],
                    y: geomtry.coordinates[i][1],
                    spatialReference: this.map.getMap().spatialReference
                })
                path.addPoint(linePoint);
            }
            //构造线上的角点
            polyline.addGeometry(path);
            if (GeometryUtil.measureLength(polyline) == 0) {
                throw (new Error('线起点终点不能重合！'));
            }
            //构造element实例
            var lineId = CommonUtil.newUUID();
            var polylineElement = new g2.sfs.Element({
                id: lineId,
                geometry: polyline,
                symbol: ploylineSymbol
            });
            //添加线
            if (isShowLine) {
                this._layer.add(polylineElement);
            }
            var pointObj = SpatialOPUtil.getPointOnPath({
                    pathGeometry: geomtry,
                    pathSrid: this.map.getMap().spatialReference,
                    distance: 0
                })
                //加载线上的点
            var pointId = CommonUtil.newUUID(),
                pointFirst = new g2.sfs.Point({
                    x: pointObj.point[0],
                    y: pointObj.point[1],
                    spatialReference: this.map.getMap().spatialReference
                }),
                pointSymbol = new g2.sfs.PictureMarkerSymbol({
                    source: options.source,
                    width: options.width,
                    height: options.height,
                    offsetX: options.width / 2,
                    offsetY: options.height / 2,
                    opacity: 1
                }),
                //文本符号  如果没有offsetX和offsetY文字在中间显示
                textSymbol = new g2.sfs.TextSymbol({
                    text: options.text || "",
                    fontSize: options.size || 15,
                    offsetX: options.offsetX || 0,
                    offsetY: options.offsetY || -21,
                    foreground: new g2.sfs.Color(options.foreground) || new g2.sfs.Color({
                        a: 255,
                        r: 255,
                        g: 0,
                        b: 0
                    }),
                    borderColor: new g2.sfs.Color(options.borderColor) || new g2.sfs.Color({
                        a: 255,
                        r: 255,
                        g: 0,
                        b: 0
                    }),
                    borderThickness: options.borderThickness || 0.1,
                    fontFamilyName: options.fontFamilyName,
                    fontWeight: options.fontWeight || 1,
                    textAlign: options.textAlign
                });
            //复合符号
            var currencySymbol = new g2.sfs.CurrencySymbol({
                markerSymbol: pointSymbol,
                textSymbol: textSymbol
            });
            var element = new g2.sfs.Element({
                id: pointId,
                geometry: pointFirst,
                symbol: currencySymbol
            });
            //图标是否可以旋转
            if (isRotate) {
                currencySymbol.markerSymbol.rotation = pointObj.point[2];
            }
            //文字是否可以旋转
            if (textIsRotate) {
                currencySymbol.textSymbol.rotation = pointObj.point[2];
            }
            this._layer.add(element);
            //tooltip
            if (tooltip) {
                tooltip = jQuery.extend(true, {}, tooltip);
                var tipHtml = tooltip.html || '<div>test</div>';
                tooltip.id = pointId;
                tooltip.offset = tooltip.offset || [10, -10];
                tooltip.className = tooltip.className || 'g2-tooltip';
                tooltip.layerId = this._layer.getLayerId();
                var newTooltip = new g2.widget.Tooltip({
                    id: tooltip.id,
                    anchor: pointFirst, //提示在地图上停靠位置
                    content: tipHtml, //提示内容
                    layerId: tooltip.layerId, //提示所在图层ID
                    offset: tooltip.offset, //位置偏移量
                    className: tooltip.className //tooltip样式
                });
                this._toolTipWare.add(newTooltip);
                var tipContainer = jQuery('[animateId=' + pointId + ']')
                    .eq(0).parent().parent().parent();
                tooltip.container = tipContainer;
                tooltip.startPoint = pointFirst;

            }
            var self = this;
            //定时执行时需要传入的参数
            var param = {
                geomtry: geomtry,
                pointId: pointId,
                lineId: lineId,
                interval: interval,
                step: 1,
                speed: speed,
                rotation: 0,
                tooltip: tooltip,
                callback: callback,
                context: context
            }
            var time = timerFactory.getTimer(interval);
            this[lineId + "draw"] = function(opts) {
                var pointObject = SpatialOPUtil.getPointOnPath({
                    pathGeometry: opts.geomtry,
                    pathSrid: self.map.getMap().spatialReference,
                    distance: opts.interval * opts.step / 1000 * opts.speed
                })

                function drawPoint(boolean) {
                    var point;
                    var ele = self._layer.find(opts.pointId);
                    if (CommonUtil.isEmptyObject(ele)) {
                        console.log("地图点已被清除");
                        //点已经被清除，清除对应的执行方法
                        var lineGradientTime = timerFactory.getTimer(opts.interval);
                        var isDelete = lineGradientTime.deleteTimerMethod(opts.interval, opts.lineId + "draw");
                        var bool = lineGradientTime.timerMethodsIsEmpty(opts.interval);
                        if (bool) {
                            timerFactory.clearTimer(lineGradientTime, interval);
                        }
                        return;
                    }
                    if (boolean) {
                        point = new g2.sfs.Point({
                            x: pointObject.point[0],
                            y: pointObject.point[1],
                            spatialReference: self.map.getMap().spatialReference
                        })
                    } else {
                        var coordinates = opts.geomtry.coordinates;
                        point = new g2.sfs.Point({
                            x: coordinates[coordinates.length - 1][0],
                            y: coordinates[coordinates.length - 1][1],
                            spatialReference: self.map.getMap().spatialReference
                        })
                    }
                    ele.geometry = point;
                    if (pointObject.point) {
                        opts.rotation = pointObject.point[2]
                    }
                    if (isRotate) {
                        ele.symbol.markerSymbol.rotation = opts.rotation;
                    }
                    if (textIsRotate) {
                        ele.symbol.textSymbol.rotation = opts.rotation;
                    }
                    self._layer.remove(ele);
                    self._layer.add(ele);
                    //update tooltip
                    if (opts.tooltip) {
                        //使用更新接口
                        if (CommonUtil.isFunction(self._toolTipWare.update)) {
                            var updateOpts = {};
                            updateOpts.id = opts.tooltip.id;
                            updateOpts.anchor = point;
                            self._toolTipWare.update(updateOpts);
                        } else {
                            //保留原来的写法
                            var overlay = self._toolTipWare
                                .IdContainer[opts.tooltip.id];
                            if (overlay) {
                                overlay.setPosition([point.x, point.y]);
                            }
                        }
                    }
                    opts.step += 1;
                }
                if (!pointObject.arrival) {
                    drawPoint(true);
                } else {
                    drawPoint(false);
                    //
                    if (CommonUtil.isFunction(opts.callback)) {
                        opts.callback.call(opts.context, opts.lineId + ',' + opts.pointId, interval);
                    }
                }
            }
            time.addTimerMothed(interval, lineId + "draw", this[lineId + "draw"], param);
            return lineId + "," + pointId;
        },
        /**
         * 线的渐变效果
         * @method
         * @param options {Object} 必填
         * @param options.pathGeojson  {wkt/geometry} 必填，路径点wkt数据和geometry数据都可以 注：坐标系和map的坐标系相同
         * @param options.lineStyle {Number} 可选，线的样式，简单直线样式,Dash = 0, DashDot = 1, DashDotDot = 2, Dot = 3, Null = 4,Solid = 5
         * @param options.lineWidth {Number} 可选，线的宽度
         * @param options.lineColor {Object} 可选，例如：{ a: 153, r: 0, g: 0, b: 255 }
         * @param options.coverPointNum {Number} 可选，渐变时一渐变区域涵盖的点数
         * @param options.interval {Number} 可选，播放每帧的间隔，单位毫秒，默认为50
         * @return options.lineId {String} 可选，线段的id
         * var lineId = animateCom.lineGradient({
         * 		pathGeojson: 'LINESTRING(115.5 35.5,116.5 34.5,117.5 34.5,117.5 36.5,115.5 36.5)',
         *		pathGeojson: {
         *		"type": "LineString",
         *		"coordinates": [
         *			[115.5, 35.5],
         *			[116.5, 34.5],
         *			[117.5, 34.5],
         *			[117.5, 36.5],
         *			[115.5, 36.5]
         *		]
         *	},
         *	interval: 50,
         *	lineColor: { a: 50, r: 0, g: 0, b: 200 },
         *	lineWidth: 3,
         *	lineStyle: 5,
         *	coverPointNum: 500,
         *})
         * */
        lineGradient: function(options) {
            //判断参数是否都赋值
            if (!options.pathGeojson) {
                throw (new Error('参数错误！'));
            }
            var lineStyle = isNaN(options.lineStyle) ? 5 : parseFloat(options.lineStyle),
                lineWidth = isNaN(options.lineWidth) ? 3 : parseFloat(options.lineWidth),
                lineColor = options.lineColor || {
                    a: 153,
                    r: 0,
                    g: 0,
                    b: 255
                },
                speed = 100000,
                interval = isNaN(options.interval) ? 50 : parseFloat(options.interval),
                //				coverPointColor = options.coverPointColor || ["#ff0000", "#ff0000", "#ff0000"],
                coverPointNum = isNaN(options.coverPointNum) ? 4 : options.coverPointNum;
            //转换geomtry
            var geom = {};
            if (typeof options.pathGeojson == "string") {
                geom = GeometryUtil.getWktReader().read(options.pathGeojson);
            } else {
                geom = GeometryUtil.getGeoJSONReader().read(options.pathGeojson);
            }
            var geomtry = GeometryUtil.getGeoJSONWriter().write(geom);
            //先画一条线
            var ploylineSymbol = new g2.sfs.SimpleLineSymbol({
                style: lineStyle,
                width: lineWidth,
                color: new g2.sfs.Color(lineColor)
            });
            var polyline = new g2.sfs.Polyline({
                spatialReference: this.map.getMap().spatialReference
            });
            //构造path实例
            var path = new g2.sfs.Path({
                spatialReference: this.map.getMap().spatialReference
            });
            for (var i = 0; i < geomtry.coordinates.length; i++) {
                var linePoint = new g2.sfs.Point({
                    x: geomtry.coordinates[i][0],
                    y: geomtry.coordinates[i][1],
                    spatialReference: this.map.getMap().spatialReference
                })
                path.addPoint(linePoint);
            }
            //构造线上的点
            polyline.addGeometry(path);
            //构造element实例
            var lineId = CommonUtil.newUUID();
            var polylineElement = new g2.sfs.Element({
                id: lineId,
                geometry: polyline,
                symbol: ploylineSymbol
            });
            //添加线
            this._layer.add(polylineElement);
            //定时器开始执行
            var self = this;
            //添加一个图层用来放置渐变的线
            var layer = new g2.carto.ElementLayer({
                id: lineId,
                map: this.map.getMap()
            });
            this.map.getMap().addLayer(layer);
            var time = timerFactory.getTimer(interval);
            var param = {
                lineArr: [], //储存渐变线的数组
                step: 1, //循环的次数
                layer: layer,
                geomtry: geomtry,
                interval: interval,
                coverPointNum: coverPointNum,
                speed: speed,
                lineId: lineId,
                polylineElement: polylineElement,
                _layer: this._layer,
                lineStyle: lineStyle,
                lineWidth: lineWidth
            }
            this[lineId + "draw"] = function(opts) {
                //先清除掉上一次循环的线段集合
                if (opts.lineArr.length > 0) {
                    for (var x = 0; x < opts.lineArr.length; x++) {
                        layer.remove(opts.lineArr[x]);
                    }
                    opts.lineArr.length = 0;
                }
                var sumTime = opts.interval / 1000 * opts.step;
                opts.step = opts.step + 1;
                var pointArr = [];
                var bool = false;
                var coordinates = opts.geomtry.coordinates;
                //获取覆盖点所有的线段
                for (var i = 1; i < opts.coverPointNum; i++) {
                    var j = opts.interval * i / 1000;
                    if (sumTime - j >= 0) {
                        var pointObject = SpatialOPUtil.getPointOnPath({
                                pathGeometry: opts.geomtry,
                                pathSrid: self.map.getMap().spatialReference,
                                distance: (sumTime * opts.speed) - (j * opts.speed)
                            })
                            //最后一个点
                        if (pointObject.arrival) {
                            if (!bool) {
                                //如果原线段存在清除掉
                                if (opts._layer.find(opts.lineId)) {
                                    opts._layer.remove(opts.polylineElement);
                                }
                                pointObject.point = [coordinates[coordinates.length - 1][0], coordinates[coordinates.length - 1][1], 0];
                                pointObject.color = g2.sfs.Color.fromHex(getRandomColor());
                                if (pointObject.point) {
                                    pointArr.push(pointObject);
                                }
                                bool = true;
                                continue;
                            }
                        }
                        //线段起始的颜色值
                        pointObject.color = g2.sfs.Color.fromHex(getRandomColor());
                        //pointObject.color = g2.sfs.Color.fromHex(coverPointColor[i - 1]);  调用时传入色带，鉴于数组太长自动生成
                        //如果返回结果有坐标存入点数组
                        if (pointObject.point) {
                            pointArr.push(pointObject);
                        }
                    }
                }
                //倒序取值，从线段前头开始生成元素
                for (var j = pointArr.length - 1; j > 0; j--) {
                    //如果下一个没有点结束本次循环
                    if (!pointArr[j - 1]) {
                        continue;
                    }
                    //初始化一个线
                    var line = new g2.sfs.Polyline({
                        spatialReference: self.map.getMap().spatialReference
                    });
                    //构造path实例
                    var pathj = new g2.sfs.Path({
                        spatialReference: self.map.getMap().spatialReference
                    });
                    var gradientLineSymbol = new g2.sfs.SimpleLineSymbol({
                        style: opts.lineStyle,
                        width: opts.lineWidth,
                        color: pointArr[j].color
                    });

                    var linePoint = new g2.sfs.Point({
                            x: pointArr[j].point[0],
                            y: pointArr[j].point[1],
                            spatialReference: self.map.getMap().spatialReference
                        })
                        //如果没有上一个值跳出本次循环
                    if (!pointArr[j - 1].point) {
                        break;
                    }
                    var linePoint1 = new g2.sfs.Point({
                        x: pointArr[j - 1].point[0],
                        y: pointArr[j - 1].point[1],
                        spatialReference: self.map.getMap().spatialReference
                    })
                    pathj.addPoint(linePoint);
                    pathj.addPoint(linePoint1);
                    line.addGeometry(pathj);
                    //构造element实例
                    var polylineElementj = new g2.sfs.Element({
                        id: CommonUtil.newUUID(),
                        geometry: line,
                        symbol: gradientLineSymbol
                    });
                    //添加线
                    opts.lineArr.push(polylineElementj);
                    opts.layer.add(polylineElementj);
                }
                //如果数组的第一组坐标匹配到线段的最后一个坐标且数组长度为1表示已经到头，开始新的循环
                try {
                    if (pointArr[pointArr.length - 1].point[0] == coordinates[coordinates.length - 1][0] && pointArr[pointArr.length - 1].point[1] == coordinates[coordinates.length - 1][1]) {
                        opts.step = 0;
                    }
                } catch (e) {}
            }
            time.addTimerMothed(interval, lineId + "draw", this[lineId + "draw"], param);
            //随机获取颜色
            function getRandomColor() {
                return '#ff' + Math.floor(Math.random() * 180 + 10) + Math.floor(Math.random() * 100 + 10);
                //return '#' + (Math.random() * 0xffffff << 0).toString(16);
            }
            return lineId;
        },
        /**
         * 展示gif动态图
         * @method
         * @memberOf G.components.AnimateComponent.prototype
         * @param options {Object} 必填
         * @param options.source {String} 必填，图片地址
         * @param options.point {Array} 必填，坐标数组[x,y]
         * @param options.offset {Array} 可选，图片位置偏移量
         * @return id {String} 返回提示类的唯一id
         * */
        loadGifPicture: function(options) {
            if (!options.source || !options.point) {
                throw (new Error('参数错误！'));
            }
            var id = CommonUtil.newUUID(),
                offset = options.offset || [-32, -32],
                source = '<img id="' + id + '" src="' + options.source + '"/>',
                point = new g2.sfs.Point({
                    x: options.point[0],
                    y: options.point[1],
                    spatialReference: this.map.getMap().spatialReference
                }),
                self = this,

                tooltip = new g2.widget.Tooltip({
                    id: id, //唯一标示
                    anchor: point, //提示在地图上停靠位置
                    content: source, //提示内容
                    layerId: self._layer.id, //提示所在图层ID
                    offset: offset //位置偏移量
                });
            this._toolTipWare.add(tooltip);
            return id;
        },
        /**
         * 更新gif动态图
         * @method
         * @memberOf G.components.AnimateComponent.prototype
         * @param options {Object} 必填
         * @param options.id {String} 必填，展示数据的唯一id
         * @param options.source {String} 必填，图片地址
         * */
        updateGifPicture: function(options) {
            if (!options.id || !options.source) {
                throw (new Error('参数错误！'));
            }
            $("#" + options.id).attr('src', options.source);
        },
        /**
         * 清除动画效果
         * @method
         * @memberOf G.components.AnimateComponent.prototype
         * @param ids {String} 必填，动画元素id,多个以逗号隔开
         */
        clear: function(ids, interval) {
            ids = ids.split(',') || [];
            if (ids.length < 1) {
                throw (new Error('参数错误！'));
            }
            for (var i = 0; i < ids.length; i++) {
                var lineGradientLayer = LayerUtil.getLayerById(this.map, ids[i]);
                if (lineGradientLayer) {
                    this.map.removeLayer(lineGradientLayer);
                }
                if (interval) {
                    var lineGradientTime = timerFactory.getTimer(interval)
                    var isDelete = lineGradientTime.deleteTimerMethod(interval, ids[i] + "draw");
                    var bool = lineGradientTime.timerMethodsIsEmpty(interval);
                    if (bool) {
                        timerFactory.clearTimer(lineGradientTime, interval);
                    }
                }
                try {
                    clearInterval(this._timerMap[ids[i]]) &&
                        (delete this._timerMap[ids[i]]);
                } catch (e) {}
                var ele = this._layer.find(ids[i]);
                if (ele) {
                    this._layer.remove(ele);
                    this._toolTipWare.remove(ids[i]);
                }
            }
        }
    });
    /**
     * 动态线效果
     * */
    component.include({
        /**
         * 点在线上流动效果
         * @method
         * @memberOf G.components.AnimateComponent.prototype
         * @param options {Object}
         * @param options.data {Array} 必填 路线的数据
         * @param options.data[0].from {Object} 必填 线条的起始点
         * @param options.data[0].from.city {String} 必填 起始点展示的名称
         * @param options.data[0].from.lnglat {Array} 必填 起始点的经纬度。注：经纬度和传入地图的坐标系保持一致
         * @param options.data[0].to {Object} 必填 线条的终点
         * @param options.data[0].to.city {String} 必填 终点展示的名称
         * @param options.data[0].to.lnglat {Array} 必填 终点的经纬度。注：经纬度和传入地图的坐标系保持一致
         * @param options.markerRadius {Number} 可选 起始点，终点的半径
         * @param options.markerColor {String} 可选 起始点，终点颜色
         * @param options.lineType {String} 可选 线条类型 solid、dashed、dotted
         * @param options.lineWidth {Number} 可选 线条宽度
         * @param options.colors {Array} 可选 线条颜色（对应数据的顺序）
         * @param options.moveRadius {Number} 可选 移动点的半径
         * @param options.fillColor {String} 可选 移动点的颜色数组
         * @param options.shadowBlur {Number} 可选 移动点阴影的大小
         * @param options.deltaAngle {Number} 可选 线段的弧度
         * @param options.interval {Number} 可选，播放每帧的间隔，单位毫秒，默认为50
         * @return id {String} 返回绘制动画的唯一id
         */
        pointFlowOnLine: function(options) {
            if (!options.data) {
                throw new Error("传入参数错误");
            }
            //储存所有canvas
            if (!this.allCanvas) {
                this.allCanvas = {};
            }
            //初始化参数
            var canvasObj = this._initParam(options, this.map.getMap());
            //初始化两个canvas
            var baseCanvasId = this._createBaseCanvas();
            //创建流动点canvas
            var animationCanvasId = this._createAnimationCanvas();
            var id = baseCanvasId + "," + animationCanvasId;
            this.allCanvas[id] = canvasObj;
            //初始化图上元素
            this._drawCanvas(id);
            //地图监听事件
            this._initMapEvents(id);
            return id;
        },
        /**
         * 初始化canvas的配置
         * @param {Object} opts 画canvas的数据	必填
         * @param {Object} map 地图对象
         * @return canvasObj {Object} canvas参数对象
         */
        _initParam: function(opts, map) {
            var canvasObj = {}
            canvasObj.markerRadius = isNaN(opts.markerRadius) ? 2 : parseFloat(opts.markerRadius);
            canvasObj.markerColor = opts.markerColor;
            canvasObj.lineType = opts.lineType || 'solid';
            canvasObj.lineWidth = isNaN(opts.lineWidth) ? 2 : parseFloat(opts.lineWidth);
            canvasObj.colors = opts.colors || ['red', 'popup', '#EDCC72', '#E2F194', '#94E08A', '#4ECDA5', '#F8AB60', 'green'];
            canvasObj.moveRadius = isNaN(opts.moveRadius) ? 3 : parseFloat(opts.moveRadius);
            canvasObj.fillColor = opts.fillColor || ["red"];
            canvasObj.shadowBlur = isNaN(opts.shadowBlur) ? 10 : parseFloat(opts.shadowBlur);
            canvasObj.data = opts.data;
            canvasObj.deltaAngle = isNaN(opts.deltaAngle) ? 0 : parseFloat(opts.deltaAngle);
            canvasObj.interval = isNaN(opts.interval) ? 50 : parseFloat(opts.interval);
            //赋值map
            this.canvasMap = map;
            //canvas的宽和高
            this.mapViewWidth = map.getViewSize()[0];
            this.mapViewHeight = map.getViewSize()[1];
            return canvasObj;
        },
        /**
         * 创建底层承载线的canvas
         */
        _createBaseCanvas: function() {
            var baseCanvas = document.createElement("canvas");
            baseCanvas.id = "canvas-" + CommonUtil.newUUID();
            this[baseCanvas.id] = baseCanvas;
            $('.ol-overlaycontainer-stopevent').prepend(baseCanvas)
            var ctx = baseCanvas.getContext('2d');
            baseCanvas.style.cssText = 'pointer-events:none;position:absolute;' + 'left:0;' + 'top:0;' + 'z-index:' + 0 + ';';
            baseCanvas.width = this.mapViewWidth;
            baseCanvas.height = this.mapViewHeight;
            baseCanvas.style.width = baseCanvas.width + 'px';
            baseCanvas.style.height = baseCanvas.height + 'px';
            this._adjustRatio(ctx);
            return baseCanvas.id;
        },
        /**
         * 创建上层承载流动点的canvas
         * **/
        _createAnimationCanvas: function() {
            var animationCanvas = document.createElement("canvas")
            animationCanvas.id = "canvas-" + CommonUtil.newUUID();
            this[animationCanvas.id] = animationCanvas;
            $('.ol-overlaycontainer-stopevent').prepend(animationCanvas)
            var ctx = animationCanvas.getContext('2d');
            animationCanvas.style.cssText = 'pointer-events:none;position:absolute;' + 'left:0;' + 'top:0;' + 'z-index:' + 1 + ';';
            animationCanvas.width = this.mapViewWidth;
            animationCanvas.height = this.mapViewHeight;
            animationCanvas.style.width = animationCanvas.width + 'px';
            animationCanvas.style.height = animationCanvas.height + 'px';
            this._adjustRatio(ctx);
            return animationCanvas.id;
        },
        _adjustRatio: function(ctx) {
            var backingStore = ctx.backingStorePixelRatio || ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
            var pixelRatio = (window.devicePixelRatio || 1) / backingStore;
            var canvasWidth = ctx.canvas.width;
            var canvasHeight = ctx.canvas.height;
            ctx.canvas.width = canvasWidth * pixelRatio;
            ctx.canvas.height = canvasHeight * pixelRatio;
            ctx.canvas.style.width = canvasWidth + 'px';
            ctx.canvas.style.height = canvasHeight + 'px';
            ctx.scale(pixelRatio, pixelRatio);
        },
        /**
         * 绘制canvas
         * @param canvasIds {String} 创建底层和上层canvas的组合id
         * **/
        _drawCanvas: function(canvasIds) {
            var self = this;
            //清除画布
            this._clearCanvasContent(canvasIds);
            setTimeout(function() {
                self._drawBaseLine(canvasIds);
            }, 1)
            this.allCanvas[canvasIds].canvasInterval = setInterval(function() {
                self._drawAnimationLine(canvasIds)
            }, self.allCanvas[canvasIds].interval);
        },
        /**
         * 绘制流动点
         * @param canvasIds {String} 创建底层和上层canvas的组合id
         * */
        _drawAnimationLine: function(canvasIds) {
            var iddArr = canvasIds.split(",");
            var animationCtx = this[iddArr[1]].getContext('2d');
            if (!animationCtx) {
                return;
            }
            animationCtx.fillStyle = 'rgba(0,0,0,0.9)';
            var prev = animationCtx.globalCompositeOperation;
            animationCtx.globalCompositeOperation = 'destination-in';
            animationCtx.fillRect(0, 0, this.mapViewWidth, this.mapViewHeight);
            animationCtx.globalCompositeOperation = prev;

            for (var i = 0; i < this.allCanvas[canvasIds].markLines.length; i++) {
                var markLine = this.allCanvas[canvasIds].markLines[i];
                markLine.drawMoveCircle(animationCtx, canvasIds, i); //移动圆点
            }
        },
        /**
         * 绘制承载线
         * @param canvasIds {String} 创建底层和上层canvas的组合id
         * */
        _drawBaseLine: function(canvasIds) {
            var iddArr = canvasIds.split(",");
            var baseCtx = this[iddArr[0]].getContext('2d');
            if (!baseCtx) {
                return;
            } //赋值路线的值
            this._addMarkLine(canvasIds);
            baseCtx.clearRect(0, 0, this.mapViewWidth, this.mapViewHeight);
            this.allCanvas[canvasIds].markLines.forEach(function(line) {
                line.drawMarker(baseCtx, canvasIds);
                line.drawLinePath(baseCtx, canvasIds);
            });
        },
        /**
         * 初始化地图事件监听
         * @param canvasIds {String} 创建底层和上层canvas的组合id
         * **/
        _initMapEvents: function(canvasIds) {
            var self = this;
            //鼠标移动事件
            var mousemove = function(button, shift, screenX, screenY, mapX, mapY, handle) {
                    if (self.allCanvas[canvasIds].canvasInterval) {
                        self._drawCanvas(canvasIds);
                    }
                }
                //鼠标按下事件
            var mousedown = function(button, shift, screenX, screenY, mapX, mapY, handle) {
                self.map.listen("mousemove", mousemove)
            }
            self.map.listen("mousedown", mousedown)

            //鼠标按下抬起事件
            var mouseup = function(button, shift, screenX, screenY, mapX, mapY, handle) {
                self.map.off("mousemove", mousemove)
            }
            self.map.listen("mouseup", mouseup)
                //地图比例尺事件
            var resolutionchanged = function(newResolution, oldResolution, level) {
                if (self.allCanvas[canvasIds].canvasInterval) {
                    self._drawCanvas(canvasIds);
                }
            }
            self.map.listen("resolutionchanged", resolutionchanged)
            var extentchanged = function(left, top, right, bottom) {
                if (self.allCanvas[canvasIds].canvasInterval) {
                    self._drawCanvas(canvasIds);
                }
            }
            self.map.listen("extentchanged", extentchanged)
        },
        /**
         * 绘制承载线
         * @param canvasIds {String} 创建底层和上层canvas的组合id
         * */
        _addMarkLine: function(canvasIds) {
            var self = this;
            this.allCanvas[canvasIds].markLines = [];
            var dataset = this.allCanvas[canvasIds].data;
            dataset.forEach(function(line, i) {
                self.allCanvas[canvasIds].markLines.push(new MarkLine({
                    id: i,
                    from: new Marker({
                        city: line.from.city,
                        location: new g2.sfs.Point({
                            x: line.from.lnglat[0],
                            y: line.from.lnglat[1],
                            spatialReference: self.map.getMap().spatialReference
                        }),
                        color: self.allCanvas[canvasIds].colors[i]
                    }),
                    to: new Marker({
                        city: line.to.city,
                        location: new g2.sfs.Point({
                            x: line.to.lnglat[0],
                            y: line.to.lnglat[1],
                            spatialReference: self.map.getMap().spatialReference
                        }),
                        color: self.allCanvas[canvasIds].colors[i]
                    })
                }));
            });
            /**
             * 符号的制作
             * opts.city 城市名称
             * opts.location 城市的坐标
             * opts.color 城市线的颜色
             * **/
            function Marker(opts) {
                this.city = opts.city;
                this.location = opts.location;
                this.color = opts.color;
            }
            /**
             * 画点
             * @param context {Object} canvas上下文
             * @param canvasIds {String} 创建底层和上层canvas的组合id
             * **/
            Marker.prototype.draw = function(context, canvasIds) {
                var pixel = self.canvasMap.getPixelFromCoordinate([this.location.x, this.location.y]);
                if (!pixel) {
                    return
                }
                context.save();
                context.beginPath();
                context.fillStyle = this.color || 'red';
                context.arc(pixel[0], pixel[1], self.allCanvas[canvasIds].markerRadius, 0, Math.PI * 2, true);
                context.closePath();
                context.fill();
                context.textAlign = 'center';
                context.textBaseline = 'middle';
                context.font = '12px Microsoft YaHei';
                context.fillStyle = this.color || "red";
                context.fillText(this.city, pixel[0], pixel[1] - 10);
                context.restore();
            };
            /**
             * 画线的方法
             * opts.id 线的id
             * opts.from 线的起点
             * opts.to 线的终点
             * **/
            function MarkLine(opts) {
                this.from = opts.from;
                this.to = opts.to;
                this.id = opts.id;
            }
            /**
             * 两点集合的处理
             * @param fromPoint {Array} 起点 [x,y]
             * @param toPoint {Array} 终点[x,y]
             * @param canvasIds {String} 创建底层和上层canvas的组合id
             * **/
            MarkLine.prototype.getPointList = function(fromPoint, toPoint, canvasIds) {
                var points = [
                    [fromPoint[0], fromPoint[1]],
                    [toPoint[0], toPoint[1]]
                ];
                var ex = points[1][0];
                var ey = points[1][1];
                points[3] = [ex, ey];
                points[1] = this.getOffsetPoint(points[0], points[3], canvasIds);
                points[2] = this.getOffsetPoint(points[3], points[0], canvasIds);
                //是否来回流动
                points = this.smoothSpline(points, false);
                //修正最后一点在插值产生的偏移
                points[points.length - 1] = [ex, ey];
                return points;
            };
            /**
             * 点的偏移量
             * @param canvasIds {Array} 开始的点
             * @param canvasIds {Array} 结束的点
             * @param canvasIds {String} 创建底层和上层canvas的组合id
             * **/
            MarkLine.prototype.getOffsetPoint = function(start, end, canvasIds) {
                var distance = this.getDistance(start, end) / 3; //除以3  改变点的运行状态
                var angle, dX, dY;
                var mp = [start[0], start[1]];
                var deltaAngle = self.allCanvas[canvasIds].deltaAngle; //偏移0弧度
                if (start[0] != end[0] && start[1] != end[1]) {
                    //斜率存在
                    var k = (end[1] - start[1]) / (end[0] - start[0]);
                    angle = Math.atan(k);
                } else if (start[0] == end[0]) {
                    //垂直线
                    angle = (start[1] <= end[1] ? 1 : -1) * Math.PI / 2;
                } else {
                    //水平线
                    angle = 0;
                }
                if (start[0] <= end[0]) {
                    angle -= deltaAngle;
                    dX = Math.round(Math.cos(angle) * distance);
                    dY = Math.round(Math.sin(angle) * distance);
                    mp[0] += dX;
                    mp[1] += dY;
                } else {
                    angle += deltaAngle;
                    dX = Math.round(Math.cos(angle) * distance);
                    dY = Math.round(Math.sin(angle) * distance);
                    mp[0] -= dX;
                    mp[1] -= dY;
                }
                return mp;
            };
            /**
             * 处理流畅的点
             * @param points {Array} 要处理的点
             * @param isLoop {Boolean} 是否来回流动
             * **/
            MarkLine.prototype.smoothSpline = function(points, isLoop) {
                var len = points.length;
                var ret = [];
                var distance = 0;
                for (var i = 1; i < len; i++) {
                    distance += this.getDistance(points[i - 1], points[i]);
                }
                var segs = distance / 2;
                segs = segs < len ? len : segs;
                for (var i = 0; i < segs; i++) {
                    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
                    var idx = Math.floor(pos);
                    var w = pos - idx;
                    var p0;
                    var p1 = points[idx % len];
                    var p2;
                    var p3;
                    if (!isLoop) {
                        p0 = points[idx === 0 ? idx : idx - 1];
                        p2 = points[idx > len - 2 ? len - 1 : idx + 1];
                        p3 = points[idx > len - 3 ? len - 1 : idx + 2];
                    } else {
                        p0 = points[(idx - 1 + len) % len];
                        p2 = points[(idx + 1) % len];
                        p3 = points[(idx + 2) % len];
                    }
                    var w2 = w * w;
                    var w3 = w * w2;

                    ret.push([this.interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), this.interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
                }
                return ret;
            };

            MarkLine.prototype.interpolate = function(p0, p1, p2, p3, t, t2, t3) {
                var v0 = (p2 - p0) * 0.5;
                var v1 = (p3 - p1) * 0.5;
                return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
            };
            /**
             * 得到两点之间的距离
             * p1 点
             * p2 点
             * **/
            MarkLine.prototype.getDistance = function(p1, p2) {
                return Math.sqrt((p1[0] - p2[0]) * (p1[0] - p2[0]) + (p1[1] - p2[1]) * (p1[1] - p2[1]));
            };
            /**
             * 画地图符号、
             * context 画板的上下文
             * @param canvasIds {String} 创建底层和上层canvas的组合id
             * **/
            MarkLine.prototype.drawMarker = function(context, canvasIds) {
                this.from.draw(context, canvasIds);
                this.to.draw(context, canvasIds);
            };
            /**
             * 画线路径
             * context 画板的上下文
             * @param canvasIds {String} 创建底层和上层canvas的组合id
             * **/
            MarkLine.prototype.drawLinePath = function(context, canvasIds) {
                var pixel1 = self.canvasMap.getPixelFromCoordinate([this.from.location.x, this.from.location.y]),
                    pixel2 = self.canvasMap.getPixelFromCoordinate([this.to.location.x, this.to.location.y]);
                if (!pixel1 || !pixel2) {
                    return
                }
                var pointList = this.path = this.getPointList(pixel1, pixel2, canvasIds);
                var len = pointList.length;
                context.save();
                context.beginPath();
                context.lineWidth = self.allCanvas[canvasIds].lineWidth;
                context.strokeStyle = self.allCanvas[canvasIds].markerColor || self.allCanvas[canvasIds].colors[this.id];
                context.shadowBlur = self.allCanvas[canvasIds].shadowBlur;
                if (!self.allCanvas[canvasIds].lineType || self.allCanvas[canvasIds].lineType == 'solid') {
                    context.moveTo(pointList[0][0], pointList[0][1]);
                    for (var i = 0; i < len; i++) {
                        context.lineTo(pointList[i][0], pointList[i][1]);
                    }
                } else if (self.allCanvas[canvasIds].lineType == 'dashed' || self.allCanvas[canvasIds].lineType == 'dotted') {
                    for (var i = 1; i < len; i += 2) {
                        context.moveTo(pointList[i - 1][0], pointList[i - 1][1]);
                        context.lineTo(pointList[i][0], pointList[i][1]);
                    }
                }
                context.stroke();
                context.restore();
                this.step = 0; //缩放地图时重新绘制动画
            };
            /**
             * 画移动的点
             * context 画板的上下文
             * @param canvasIds {String} 创建底层和上层canvas的组合id
             * **/
            MarkLine.prototype.drawMoveCircle = function(context, canvasIds, num) {
                var pixel1 = self.canvasMap.getPixelFromCoordinate([this.from.location.x, this.from.location.y]),
                    pixel2 = self.canvasMap.getPixelFromCoordinate([this.to.location.x, this.to.location.y]);
                if (!pixel1 || !pixel2) {
                    return
                }
                var pointList = this.path || this.getPointList(pixel1, pixel2, canvasIds);
                context.save();
                context.fillStyle = self.allCanvas[canvasIds].fillColor[num] || "red";
                context.shadowColor = self.allCanvas[canvasIds].fillColor[num] || "red";
                context.shadowBlur = self.allCanvas[canvasIds].shadowBlur;
                context.beginPath();
                this.step += 1;
                if (!pointList[this.step]) {
                    this.step = 0;
                }
                context.arc(pointList[this.step][0], pointList[this.step][1], self.allCanvas[canvasIds].moveRadius, 0, Math.PI * 2, true);
                context.fill();
                context.closePath();
                context.restore();
                this.step += 1;
            };
        },
        /**
         * 清除canvas中的内容
         * @param canvasIds {String} 创建底层和上层canvas的组合id
         * */
        _clearCanvasContent: function(canvasIds) {
            clearInterval(this.allCanvas[canvasIds].canvasInterval);
            this.allCanvas[canvasIds].canvasInterval = null;
            var iddArr = canvasIds.split(",");
            var baseCtx = this[iddArr[0]].getContext('2d');
            baseCtx.clearRect(0, 0, this.mapViewWidth, this.mapViewHeight);
            var animationCtx = this[iddArr[1]].getContext('2d');
            animationCtx.clearRect(0, 0, this.mapViewWidth, this.mapViewHeight);
        },
        /**
         * 清除点在线上流动效果
         * @method
         * @memberOf G.components.AnimateComponent.prototype
         * @param id {String} 绘制流动动画的唯一id,如果不传则清除全部动画效果
         * **/
        clearFlowAnimation: function(id) {
            var self = this;
            if (id) {
                clearCanvas(id);
            } else {
                if (!CommonUtil.isEmptyObject(this.allCanvas)) {
                    for (var key in this.allCanvas) {
                        clearCanvas(key);
                    }
                }
            }

            function clearCanvas(ids) {
                clearInterval(self.allCanvas[ids].canvasInterval);
                self.allCanvas[ids].canvasInterval = null;
                var idsArr = ids.split(",");
                self[idsArr[0]].remove();
                self[idsArr[1]].remove();
                delete self.allCanvas[ids];
            }
        }
    })
    return component;
});